<template>
  <div class="standardpage reports flights">
    <b-card class="m-0 lowpadding">
      <b-card-header class="px-3 m-0" id="charters-header">
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            {{ options.title }}</b-col
          >
          <b-col cols="12" sm="6" class="mt-2 mt-sm-0">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!find"
                        @click="find = ''"
                      >
                        <i v-if="find" class="fa fa-remove"></i>
                        <i v-if="!find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>

                <b-button
                  id="event-refresh"
                  size="sm"
                  squared
                  variant="outline-primary"
                  class="card-header-action ml-1"
                  @click="refresh()"
                >
                  <i class="fa fa-refresh"></i>
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
    </b-card>
    <b-card-group class="mt-3" deck>
      <b-card no-body class="overflow-hidden">
        <template #header>
          <h4 class="mb-0">TP Event Itineraries</h4>
        </template>
        <b-row class="px-3 mt-2">
          <b-col cols="11">
            <b-form-group label-cols="12" label="Event" label-size="sm">
              <treeselect
                placeholder="Select event..."
                searchPromptText="Type at least 4 chars..."
                v-model="eventcode"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadEvent"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
                @select="eventselect"
              >
                <!-- <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div> -->
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="11">
            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
              <treeselect
                placeholder="Select slac..."
                searchPromptText="Type at least 3 chars..."
                v-model="slac"
                :disabled="eventcode ? false : true"
                :multiple="true"
                :clearable="true"
                :async="true"
                :load-options="treeselect_loadSLAC"
                :show-count="true"
                :flatten-search-results="true"
                :disable-branch-nodes="true"
                :matchKeys="['id']"
                search-nested
              >
                <div slot="value-label" slot-scope="{ node }">
                  {{ node.raw.id }}
                </div>
              </treeselect>
            </b-form-group>
          </b-col>
          <b-col cols="11">
            <b-form-group label-cols="12" label="Passenger" label-size="sm">
              <b-input-group class="treeselect_all justify-content-end pr-2px">
                <label
                  style="padding-top: 0.3em"
                  :class="
                    options_passsenger.length > 0 ? 'text-primary mr-2' : 'mr-2'
                  "
                  >Found: {{ options_passsenger.length }},
                </label>
                <span
                  style="padding-top: 0.3em; font-size: 11px"
                  :class="options_passsenger.length > 0 ? 'text-primary' : null"
                  >Select All</span
                >
                <b-form-checkbox
                  id="passenger_all"
                  v-model="passenger_all"
                  :disabled="options_passsenger.length == 0 ? true : false"
                  class="z-0"
                >
                </b-form-checkbox>
              </b-input-group>
              <treeselect
                v-model="passenger"
                :clearable="true"
                :multiple="true"
                :disabled="eventcode ? false : true"
                :options="options_passsenger"
                :max-height="110"
              ></treeselect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <b-card no-body class="overflow-hidden">
        <template #header>
          <h4 class="mb-0">Guestia Mobile Platform</h4>
        </template>
        <b-row no-gutters>
          <b-col md="3">
            <b-card-img
              src="/img/brand/guestia.png"
              alt="Image"
              class="rounded-0"
            ></b-card-img>
          </b-col>
          <b-col md="9">
            <b-card-body>
              <b-form-textarea
                id="textarea-sync"
                v-model="platform_messages"
                placeholder="platform messages"
                rows="12"
                disabled
              ></b-form-textarea>
              <b-row class="px-3 mt-3 mb-3">
                <b-row>
                  <b-col cols="12">
                    <b-button
                      size="sm"
                      squared
                      variant="outline-success"
                      @click="save"
                      :disabled="passenger.length == 0"
                    >
                      <i class="fa fa-wifi mr-1"></i>
                      Publish Event Itineraries
                    </b-button>
                  </b-col>
                </b-row>
              </b-row>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </b-card-group>
    <b-card-footer class="mt-3">
      <b-row>
        <b-col class="text-left">
          <div v-if="busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
          </div>
          <div v-else>
            <span v-html="message"></span>
          </div>
        </b-col>
      </b-row>
    </b-card-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

// import { Splitpanes, Pane } from "splitpanes";
// import "splitpanes/dist/splitpanes.css";

export default {
  name: "Guestia",
  // components: {
  //   Splitpanes,
  //   Pane,
  // },
  computed: {
    ...mapGetters(["user", "window"]),
  },
  watch: {
    async slac() {
      await this.load();
    },
    async passenger_all() {
      console.log("passenger_all", this.passenger_all);
      this.passenger = [];
      if (this.passenger_all) {
        for (var i = 0; i < this.options_passsenger.length; i++) {
          this.passenger.push(this.options_passsenger[i].id);
        }
      }
    },
  },
  data() {
    return {
      busy: false,
      message: null,
      eventcode: null,
      slac: [],
      passenger: [],
      options_passsenger: [],
      passenger_all: false,
      find: null,
      token: {},
      event: {},
      item: {},
      platform_messages: null,
      options: {
        title: "Guestia",
        icon: "fa fa-mobile",
      },
    };
  },
  methods: {
    async load() {
      console.log("load()");
      this.platform_messages = null;

      let variables = {
        eventcode: this.eventcode,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query events($eventcode: String, $dateformat: String) {
              events(eventcode: $eventcode, dateformat: $dateformat) {
                eventcode
                eventname
                dateevent
              }
            }
          `,
          variables,
        });

        if (response.data.events.length > 0) {
          this.event = response.data.events[0];
        }
      } catch (error) {
        console.log(error);
      }

      variables = {
        eventcode: this.eventcode,
        slac: this.slac ? this.slac.join(",") : null,
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query itineraries($eventcode: String, $slac: String) {
              itineraries(eventcode: $eventcode, slac: $slac) {
                id
                eventcode
                slac
                passenger
                days
              }
            }
          `,
          variables,
        });

        this.options_passsenger = [];
        for (var i = 0; i < response.data.itineraries.length; i++) {
          let item = response.data.itineraries[i];
          this.options_passsenger.push({
            id: item.id,
            label: item.passenger + " | " + item.slac,
          });
        }

        
      } catch (error) {
        console.log(error);
      }

      //  Call token here?
      this.platform_message("Checking with Guestia events...");

      variables = {
        eventcode: this.eventcode,
      };
      try {
        const response = await this.$apollo.query({
          query: gql`
            query xapi_guestia_events($eventcode: String) {
              xapi_guestia_events(eventcode: $eventcode) {
                id
                eventcode
                eventname
                dateevent
              }
            }
          `,
          variables,
        });

        console.log(response.data.xapi_guestia_events);

        this.item = null;
        if (response.data.xapi_guestia_events.length > 0) {
          this.platform_message("Event was found: " + this.eventcode);
          this.item = response.data.xapi_guestia_events[0];
        } else {
          this.platform_message(
            "Event was not found: '" + this.eventcode + "'  will be created."
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      console.log("save()");
      this.platform_messages = null;

      this.platform_message("Publishing event '" + this.eventcode + "'");

      if (!this.item) {
        this.platform_message("Creating event '" + this.eventcode + "'");
        this.item = {
          eventcode: this.event.eventcode,
          eventname: this.event.eventname,
          dateevent: this.event.dateevent,
        };
      }

      this.platform_message(
        "Publishing event itineraries for " +
          this.passenger.length +
          " guest(s)."
      );

      let variables = { rows: [this.$helpers.prepareforSave(this.item)] };
      console.log("variables", variables);

      // try {
      //   const response = await this.$apollo.mutate({
      //     mutation: gql`
      //       mutation xapi_guestia_saveevents(
      //         $rows: [xapi_guestia_event_input]
      //       ) {
      //         xapi_guestia_saveevents(rows: $rows) {
      //           id
      //         }
      //       }
      //     `,
      //     variables,
      //   });
      //   // console.log(response);
      //   this.message = "<span class='text-primary'>Saved it.</span>";
      // } catch (error) {
      //   this.message = "<span class='text-danger'>" + error.message + "</span>";
      // }

      this.platform_message("Saved it.");
    },
    async eventselect(n) {
      this.eventcode = n.id;
      this.options.title = "Guestia " + n.label;

      await this.load();
    },
    platform_message(t) {
      if (!this.platform_messages) {
        this.platform_messages = t;
      } else {
        this.platform_messages += "\n" + t;
      }
    },
    async getToken() {
      let variables = {};
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query xapi_guestia_token {
              xapi_guestia_token {
                access_token
                expires_in
                token_type
                scope
              }
            }
          `,
          variables,
        });

        if (response.data.xapi_guestia_token) {
          this.token = response.data.xapi_guestia_token;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>